module.exports = __webpack_public_path__ + "assets/img/help_tj6.5a3b2d35.png";